export default __webpack_public_path__ + "e571800c9718f51d8894eeaf00ebdc28.woff2?proxy=wpt-abc";